import React from 'react'
import { motion } from 'framer-motion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { getColorRed } from '../utils/themeUtils'

const NavBar = ({
  theme,
  currentTheme,
  onNext,
  onPrevious,
  iconBg,            // string, e.g. "#ffcc00"
  currentIndex,      // number
  dataSet,           // total number of items
  navTitle = "Question",
  showEnd = false,
  onEndTest
}) => {
  const getNavBackground = () =>
    currentTheme === 'light'
      ? theme.homeCard.end_light
      : theme.homeCard.end_dark

  const getTextColor = () =>
    currentTheme === 'light'
      ? theme.text.light
      : theme.text.dark

  const total = dataSet
  const isFirst = currentIndex === 0
  const isLast = currentIndex === total - 1
  const progressPercent = ((currentIndex + 1) / total) * 100

  return (
    <div className="fixed bottom-6 left-0 right-0 flex items-center justify-center px-6">
      <div
        className="relative flex items-center justify-between w-full max-w-3xl rounded-xl shadow-lg p-4"
        style={{ backgroundColor: getNavBackground() }}
      >
        {/* ← Prev */}
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={onPrevious}
          disabled={isFirst}
          className="w-12 h-12 rounded-full flex items-center justify-center"
          style={{
            backgroundColor: iconBg,
            color: getTextColor(),
            opacity: isFirst ? 0.5 : 1
          }}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </motion.button>

        {/* Progress + Title */}
        <div className="flex-1 mx-4">
          <div
            className="text-center mb-1 font-medium"
            style={{ color: getTextColor() }}
          >
            {navTitle} {currentIndex + 1} of {total}
          </div>

          <div
            className="relative h-2 bg-gray-200 dark:bg-red-700 rounded-full overflow-hidden"
            style={{ backgroundColor: iconBg }}
          >
            {/* Filled portion */}
            <div
              className="absolute top-0 left-0 h-full transition-all duration-300 ease-in-out"
              style={{
                width: `${progressPercent}%`,
                backgroundColor: iconBg
              }}
            />
            {/* White circle indicator */}
            <div
              className="absolute w-2 h-2 rounded-full shadow-lg"
              style={{
                backgroundColor: '#fff',
                top: '50%',
                left: `${progressPercent}%`,
                transform: 'translate(-50%, -50%)'
              }}
            />
          </div>

          <div className="mt-2 flex justify-between">
            {total > 10 ? (
              [1, total / 4, total / 2, (total * 3) / 4, total].map((val, i) => (
                <span
                  key={i}
                  className="text-xs"
                  style={{ color: getTextColor() }}
                >
                  {Math.round(val)}
                </span>
              ))
            ) : (
              Array.from({ length: total }).map((_, idx) => (
                <span
                  key={idx}
                  className={`text-xs ${idx === currentIndex ? 'font-bold' : ''}`}
                  style={{
                    color: idx === currentIndex ? iconBg : getTextColor(),
                    transform: idx === currentIndex ? 'scale(1.2)' : 'scale(1)',
                    transition: 'all 0.2s ease-in-out'
                  }}
                >
                  {idx + 1}
                </span>
              ))
            )}
          </div>
        </div>

        {/* → Next */}
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={onNext}
          disabled={isLast}
          className="w-12 h-12 rounded-full flex items-center justify-center"
          style={{
            backgroundColor: iconBg,
            color: getTextColor(),
            opacity: isLast ? 0.5 : 1
          }}
        >
          <FontAwesomeIcon icon={faArrowLeft} className="rotate-180" />
        </motion.button>

        {/* End Test */}
        {showEnd && (
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onEndTest}
            className="absolute left-full ml-10 top-0 h-full flex items-center justify-center px-4 min-w-max whitespace-nowrap rounded-lg font-medium text-sm"
            style={{
              backgroundColor: getColorRed(theme, currentTheme),
              color: getTextColor()
            }}
          >
            End Test
          </motion.button>
        )}
      </div>
    </div>
  )
}

export default NavBar
